import { HighlightLogo } from '@highlight/ui'

import { HeroGradient } from './hero-gradient'

/** Steps 1 and 5: the brand mark glowing over the gradient. */
export function HeroWelcome() {
  return (
    <HeroGradient className="items-center justify-center">
      <span className="relative flex size-[58px] items-center justify-center">
        <span className="bg-brand/70 absolute -inset-5 rounded-full blur-[18px]" />
        <HighlightLogo size="lg" tone="dark" className="relative">
          <HighlightLogo.Icon />
        </HighlightLogo>
      </span>
    </HeroGradient>
  )
}
